<i18n src="@/lang/actions" />
<i18n src="@/lang/amo" />
<i18n>
    {
    "en": {
    "copied_to_clipboard": "Copied to clipboard",
    "embedded_title": "Embedded code"
    },
    "ua": {
    "copied_to_clipboard": "Copied to clipboard",
    "embedded_title": "Вбудований код"
    },
    "ru": {
    "copied_to_clipboard": "Copied to clipboard",
    "embedded_title": "Встроенный код"
    }
    }
</i18n>

<template>
  <div>
    <div v-for="(value, entity) in params[script.code]" :key="entity">
      <section-divider :text="$t(`amo.entity.name.${entity}`)" />
      <el-row
        v-for="v in value"
        :key="v"
        type="flex"
        justify="space-between"
        align="middle"
      >
        <span v-text="v" />
        <el-tooltip class="item" effect="dark" :content="v" placement="left">
          <el-cascader
            clearable
            v-model="script.params[entity][v]"
            :options="cascaderOptions.customFields"
            :props="{ expandTrigger: 'hover' }"
          />
        </el-tooltip>
      </el-row>
    </div>
    <el-row v-if="showEmbeddedCode">
      <br />
      <el-card>
        <el-row
          slot="header"
          type="flex"
          justify="space-between"
          align="middle"
        >
          <span v-text="$t('embedded_title')" />
          <el-button
            type="text"
            icon="el-icon-paperclip"
            @click="handleCopyToClipboard"
          />
        </el-row>
        <el-row v-text="script.embeddedString" style="word-wrap: break-word" />
      </el-card>
    </el-row>
    <br />
    <el-row type="flex" justify="end" align="middle">
      <el-button type="primary" @click="$emit('onSave', script)"
        >{{ $t("actions.save") }}
      </el-button>
    </el-row>
    <br />
  </div>
</template>

<script>
import { mapState } from "vuex";
import SectionDivider from "../services_v3/elements/SectionDivider";

export default {
  name: "settings-block",
  components: { SectionDivider },
  props: {
    script: Object,
    customFields: Object,
    showEmbeddedCode: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleCopyToClipboard() {
      this.$copyText(this.script.embeddedString);
      this.$notify({
        type: "info",
        message: this.$t("copied_to_clipboard")
      });
    }
  },
  computed: {
    ...mapState({
      params: state => state.cache.allowed_scripts.script_params
    }),
    cascaderOptions() {
      let f = (value, label, children = undefined) => {
        return { value, label, children };
      };
      let customFields = Object.keys(this.customFields).map(v => {
        return f(
          v,
          this.$t(`amo.entity.name.${v}`),
          this.customFields[v].map(vv => {
            return f(vv.id, vv.name);
          })
        );
      });
      return { customFields };
    }
  }
};
</script>

<style scoped></style>
